import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import CategorizesPosts from '../components/CategorizesPosts';
import { graphql } from 'gatsby';
import Seo from '../components/Seo';

const CategoryTemplate = ({ data }) => {
  const {
    categories: { nodes: categoryPosts },
  } = data;
  return (
    <Layout>
      <Seo Sitetitle={categoryPosts[0].category} />
      <PageHeader title={`Blog | ${categoryPosts[0].category}`} />
      <CategorizesPosts categoryPosts={categoryPosts} />
    </Layout>
  );
};

export const query = graphql`
  query GetCategories($category: String) {
    categories: allStrapiBlogs(filter: { category: { eq: $category } }) {
      nodes {
        id
        slug
        date
        title
        category
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default CategoryTemplate;
